import { useMutation } from 'react-query'
import { useNavigate, useParams } from 'react-router-dom'

import AuthDataService from 'src/services/auth.service'
import { IUserSignupDto } from 'src/types'

const useSignup = () => {
  const navigate = useNavigate()
  const { token } = useParams()

  return useMutation((dto: IUserSignupDto) => AuthDataService.signup({ ...dto, token }), {
    onSuccess: (data) => {
      if (!data) return

      if (!('account' in data)) {
        navigate(`/register/email/${data.activation_token}`)
      }
    },
  })
}

export { useSignup }
